import type { ReportTemplate } from 'api/analytics-reports/types';
import type { Dayjs } from 'dayjs';
import { buildQuickReportPayload } from 'app/modules/analytics/modules/reports/utils/buildQuickReportPayload';
import type { ReportProfileEditorState } from 'app/modules/analytics/modules/reports/types/ReportProfileEditorState';
import type { ProfileGroup } from 'types/Page';

export interface BuildOverviewQuickReportPayloadInput {
  name: string;
  datePreset: string | null;
  startDate: Dayjs;
  endDate: Dayjs;
  isGroupSelected: boolean;
  selectedProfileGroup: ProfileGroup | null;
  template: ReportTemplate;
  profileCards: ReportProfileEditorState[];
  /** TODO(overview-pdf-be): poslať z AnalyticsContext keď BE podporí compare na create. */
  compareSince?: string;
  compareUntil?: string;
}

/**
 * TODO(overview-pdf-be): Po doručení BE nahradiť buildQuickReportPayload týmto payloadom:
 * - template: OVERVIEW_REPORT_TEMPLATE_CODE ('overview')
 * - profiles z buildOverviewQuickReportProfileCards + sections: [{ kind: 'overview' }]
 * - compare_since / compare_until keď je zapnuté porovnanie na Overview tabe
 *
 * @see overviewPdfExportBackendGaps.ts
 */
export function buildOverviewQuickReportPayload(
  input: BuildOverviewQuickReportPayloadInput,
) {
  return buildQuickReportPayload({
    scope: 'full',
    name: input.name,
    profileCards: input.profileCards,
    datePreset: input.datePreset,
    startDate: input.startDate,
    endDate: input.endDate,
    isGroupSelected: input.isGroupSelected,
    selectedProfileGroup: input.selectedProfileGroup,
    template: input.template,
    templateCode: input.template.code,
  });
}
